import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export default function PromoBanner() {
  const { currentUser, userProfile } = useAuth();
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("promoBannerDismissed")) {
      setShow(false);
      return;
    }
    if (!currentUser) {
      setShow(true);
      return;
    }
    async function checkEligibility() {
      try {
        const res = await fetch(`${BACKEND_URL}/api/validate-coupon`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code: "WELCOME149",
            email: currentUser.email || "",
            phone: userProfile?.phone || "",
            cartItems: [{ id: "hara-namak" }],
          }),
        });
        const data = await res.json();
        setShow(data.valid);
      } catch (err) {
        setShow(true);
      }
    }
    checkEligibility();
  }, [currentUser, userProfile]);

useEffect(() => {
    function handleScroll() {
      const scrolled = window.scrollY;
      const halfway = document.body.scrollHeight / 2;
      if (scrolled > halfway) {
        setShow(false);
      } else if (!sessionStorage.getItem("promoBannerDismissed") && !dismissed) {
        setShow(true);
      }
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dismissed]); 
 function handleDismiss(e) {
    e.stopPropagation();
    sessionStorage.setItem("promoBannerDismissed", "true");
    setDismissed(true);
    setShow(false);
  }

  if (!show || dismissed) return null;

  return (
    <>
      <style>{`
        @keyframes floatUp {
          from { opacity: 0; transform: translateX(-50%) translateY(20px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
        .promo-pill {
          position: fixed;
          bottom: 80px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9998;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #2D5016;
          color: #F7F0E3;
          padding: 10px 18px 10px 16px;
          border-radius: 100px;
          box-shadow: 0 8px 32px rgba(45,80,22,0.25), 0 2px 8px rgba(0,0,0,0.15);
          animation: floatUp 0.5s cubic-bezier(0.22,1,0.36,1) 1s both;
          white-space: nowrap;
          cursor: default;
          font-family: 'Inter', sans-serif;
        }
        .promo-pill-text {
          font-size: 0.78rem;
          font-weight: 500;
          letter-spacing: 0.01em;
          color: rgba(247,240,227,0.85);
        }
        .promo-pill-code {
          background: #C8860A;
          color: #fff;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          padding: 3px 10px;
          border-radius: 100px;
        }
        .promo-pill-divider {
          width: 1px;
          height: 16px;
          background: rgba(247,240,227,0.2);
        }
        .promo-pill-price {
          font-size: 0.82rem;
          font-weight: 700;
          color: #F7F0E3;
        }
        .promo-pill-close {
          background: none;
          border: none;
          color: rgba(247,240,227,0.5);
          font-size: 0.9rem;
          cursor: pointer;
          padding: 0;
          line-height: 1;
          margin-left: 2px;
          transition: color 0.2s;
        }
        .promo-pill-close:hover { color: #F7F0E3; }
        @media (max-width: 480px) {
          .promo-pill { bottom: 80px; padding: 9px 14px 9px 12px; }
          .promo-pill-text { font-size: 0.72rem; }
        }
      `}</style>

      <div className="promo-pill">
        <span className="promo-pill-code">WELCOME149</span>
        <span className="promo-pill-text">First salt for just</span>
        <span className="promo-pill-price">₹149</span>
        <div className="promo-pill-divider"></div>
        <button className="promo-pill-close" onClick={handleDismiss}>✕</button>
      </div>
    </>
  );
}